module.exports = __webpack_public_path__ + "media/2-e.bc8e4ef3.wav";